import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InfoSearchPage, ModalAddInfoPage } from './InfoSearch';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    InfoSearchPage,
    ModalAddInfoPage,
  ],
  imports: [
    IonicPageModule.forChild(InfoSearchPage),
    CalendarModule,
    NgxPaginationModule,
  ],

  entryComponents: [
    ModalAddInfoPage,
  ],
  providers: [
    RestProvider,
  ]
})
export class InfoSearchPageModule {}



// WEBPACK FOOTER //
// ./src/pages/InfoSearch/InfoSearch.module.ts